import { render, staticRenderFns } from "./ProductDrawer.vue?vue&type=template&id=063097ab"
import script from "./ProductDrawer.vue?vue&type=script&lang=js"
export * from "./ProductDrawer.vue?vue&type=script&lang=js"
import style0 from "./ProductDrawer.vue?vue&type=style&index=0&id=063097ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports